import { render } from "./CompaniesDetails.vue?vue&type=template&id=58cf83cf&scoped=true"
import script from "./CompaniesDetails.vue?vue&type=script&lang=js"
export * from "./CompaniesDetails.vue?vue&type=script&lang=js"

import "./CompaniesDetails.vue?vue&type=style&index=0&id=58cf83cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cf83cf"]])

export default __exports__